import React from "react";
import { Controller } from "react-hook-form";
import { FormGroup } from "reactstrap";
import { H4, H6, P } from "../../AbstractElements";
import { RadioSelectField } from "../../CommonElements";
import ImageWithLightbox from "./ImageWithLightbox";
import seragamPria from "../../assets/images/seragam_pria.jpg";
import seragamWanita from "../../assets/images/seragam_wanita.jpg";

const DressCode = ({ control, watch, setValue, preview=false }) => {
  const isSubmitted = watch("submit") === true | preview;
  const optionsPakaian = [
    {
      id: 1,
      name: "S",
      value: "S (LD 48, PB 65)",
    },
    {
      id: 2,
      name: "M",
      value: "M",
    },
    {
      id: 3,
      name: "L",
      value: "L",
    },
    {
      id: 4,
      name: "XL",
      value: "XL",
    },
    {
      id: 5,
      name: "2XL",
      value: "2XL",
    },
    {
      id: 5,
      name: "3XL",
      value: "3XL",
    },
    {
      id: 6,
      name: "4XL",
      value: "4XL",
    },
    {
      id: 7,
      name: "5XL",
      value: "5XL",
    },
    {
      id: 8,
      name: "Yang lain:",
      value: "other",
    }
  ];

  const optionsLengan = [
    {
      id: 1,
      name: "Lengan Panjang",
      value: "Lengan Panjang",
    },
    {
      id: 2,
      name: "Lengan Pendek",
      value: "Lengan Pendek",
    }
  ];

  // Use watch to get current form values for showing the text input value
  const watchUkuranLainnya = watch("ukuran_pakaian_lainnya");

  return (
    <div>
      <div className="purple-header mb-4 bg-primary">
        <h3 className="text-white p-3">Dress Code</h3>
      </div>

      <div className="form-section-content">
        <P className="mb-4">Dress code akan digunakan pada hari kedua atau sesuai info lanjutan dari panitia. <br />Bahan seragam yang diberikan dryfit, menggunakan kerah bagi pria dan tidak berkerah bagi wanita.</P>
        
        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px", display: "flex", flexDirection: "row", alignItems: "center"}}>
          <div style={{flex: 1, textAlign: "center"}}>
            <H4 className="mb-4">Ukuran Seragam Pria</H4>
            <ImageWithLightbox
              src={seragamPria}
              alt="Seragam Pria"
              style={{
                margin: "auto",
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                display: "block"
              }}
            />
          </div>
          <div style={{flex: 1, textAlign: "center"}}>
            <H4 className="mb-4">Ukuran Seragam Wanita</H4>
            <ImageWithLightbox
              src={seragamWanita}
              alt="Seragam Wanita"
              style={{
                margin: "auto",
                width: "100%",
                maxWidth: "600px",
                height: "auto",
                display: "block"
              }}
            />
          </div>
        </FormGroup>

        <FormGroup style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <label>Jika Bapak/Ibu ingin memesan dresscode dengan pembiayaan pribadi, silakan isi form di bawah ini.<br/>
Untuk perkiraan harga sementara sbb:<br/>
- Lengan pendek Rp.210.000<br/>
- Lengan panjang Rp.220.000</label>
          <Controller
            name="ukuran_pakaian"
            control={control}
            render={({field, fieldState}) => (
              <RadioSelectField
                label=""
                options={optionsPakaian}
                fieldState={fieldState}
                withTextInput={true}
                textInputOption="other"
                textInputName="ukuran_pakaian_lainnya"
                textInputValue={watchUkuranLainnya}
                textInputPlaceholder="Ukuran pakaian lainnya"
                onTextInputChange={(e) => {
                  if (!isSubmitted) {
                    setValue("ukuran_pakaian_lainnya", e.target.value);
                  }
                }}
                {...field}
                disabled={watch("submit") | preview}
              />
            )}
          />
        </FormGroup>

        <FormGroup className="mt-4" style={{border: "1px solid #ccc", padding: "20px", borderRadius: "5px"}}>
          <Controller
            name="lengan_pakaian"
            control={control}
            render={({field, fieldState}) => (
              <RadioSelectField
                label="Lengan Pakaian"
                options={optionsLengan}
                fieldState={fieldState}
                {...field}
                disabled={watch("submit") | preview}
              />
            )}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default DressCode;